import { Bone, SHIMMER_STYLE } from "@ui/Molecules/Skeleton/Bone";

export function FilterRailSkeleton() {
	return (
		<div className="flex h-full flex-col gap-6 border-r border-[var(--border-default)] bg-[var(--surface-default)] px-6 pb-10 pt-6">
			<style>{SHIMMER_STYLE}</style>
			<div className="flex items-baseline justify-between">
				<Bone width={70} height={20} />
				<Bone width={48} height={13} />
			</div>
			{[0, 1, 2, 3].map((group) => (
				<div key={group} className="flex flex-col gap-2.5">
					<Bone width={90} height={11} />
					<div className="flex flex-wrap gap-2">
						{[64, 88, 72, 56].map((w) => (
							<Bone key={w} width={w} height={30} radius="var(--radius-pill)" />
						))}
					</div>
				</div>
			))}
		</div>
	);
}
